<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <div class="addTask">
              <div [formGroup]="form">
                <div class="row">
                  <div class="col-md-12 col-lg-12">
                      <div class="col-md-11 col-11" style="padding: 0">
                        <div class="form-group">
                          <label>Task Name <span class="required-field">*</span></label>
                          <input formControlName="name" type="text" class="form-control">
                          <span class="err" *ngIf="form.get('name').invalid && formSubmit">user name required</span>
                        </div>
                      </div>
                      <div class="col-md-1 col-1 task-button">
                        <div class="form-group">
                          <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#exampleModal" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                          </svg>
                        </div>
                      </div>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <label>Description</label>
                      <textarea name="" formControlName="description" id="" style="height: 70px"  class="form-control" cols="30" rows="10"></textarea>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Assign To</label>
                      <select class="form-control" formControlName="assignedTo">
                        <option *ngFor="let user of usersWithoutCustomers" [value]="user.userId">{{user.userName}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group ">
                      <label>Tag Users</label>
                      <ng-multiselect-dropdown
                      [placeholder]="'tag users'" [ngModelOptions]="{standalone: true}"
                      [settings]="tagUsersdropdownSettings"
                      [data]="tagUsersdropdownList"
                      [(ngModel)]="tagUsersselectedItems"
                      class="form-control"
                      style="padding: 0;border: none"
                      (onSelect)="onItemSelect($event)"
                      (onSelectAll)="onSelectAll($event)"
                      >
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Exp Start Date</label>
                      <input formControlName="taskExpStartDate" type="date" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Exp End Date</label>
                      <input formControlName="taskExpEndDate" type="date" class="form-control">
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group" *ngFor="let list of keyValueList">
                      <label>{{list.key}}</label>
                      <input type="text" class="form-control" *ngIf="list.possibleValue.length == 0" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                      <select class="form-control" *ngIf="list.possibleValue.length != 0" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                        <option *ngFor="let possibleValue of list.possibleValue" [value]="possibleValue">{{possibleValue}}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12" hidden="true">
                    <label class="image-upload-container btn btn-bwm">
                        <!-- <span>Select Image</span> -->
                        <input #imageInput
                              type="file" id="add-image-btn"
                              accept="image/*" hidden="true"
                              (change)="onChange($event)">
                    </label>
                </div>

                <div class=" media-content">
                    <div class="mr-2 image-btn" (click)="addImageBtn()">
                      <span>+ Add Image</span>
                    </div>
                    <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;" *ngFor="let image of images" class="mr-2">
                        <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
                    </div>
                </div>
                
                <!-- <div class="" style="margin: 0;padding: 0;" hidden="true">
                  <label class="image-upload-container btn btn-bwm">
                      <input #imageInput
                            type="file" id="add-video-btn"
                            accept="video/*" hidden="true"
                            (change)="onSelectFile($event)">
                    </label>
                </div>
                <div class=" media-content">
                  <div class="mr-2 image-btn" (click)="addVideoBtn()">
                    <span>+ Add video</span>
                  </div>
                  <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                      <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                  </div>
                </div> -->
              
                <!-- <div class="" style="margin: 0;padding: 0;" hidden="true">
                  <label class="image-upload-container btn btn-bwm">
                      <input #imageInput
                            type="file" id="add-audio-btn"
                            accept="audio/*" hidden="true"
                            (change)="onSelectFile($event)">
                    </label>
                </div>
                <div class=" media-content">
                  <div class="mr-2 image-btn" (click)="addAudioBtn()">
                    <span>+ Add Audio</span>
                  </div>
                  <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                      <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                  </div>
                </div>
              
                <div *ngFor="let audio of audios" class="mr-2">
                  <audio controls>
                    <source src="{{audio}}" type="audio/mpeg">
                  </audio>
                </div> -->
              </div>
              <div class="modal-footer">
                  <button type="button" (click)="addTask()" *ngIf="!addButton" class="btn btn-primary">Add Task</button>
              </div>
          </div>
        </div>
    </div>
</div>



<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Tasks</h5>
      </div>
      <div class="modal-body">
        <div class="status-table">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 20%;">Task SlNo</th>
                <th style="width: 20%;">Task Name</th>
                <th style="width: 40%;">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let task of taskMasters" (click)="autoFill(task.name,task.description)">
                <td>{{task.seqNo}}</td>
                <td>{{task.name}}</td>
                <td>{{task.description}}</td>
              </tr>
            </tbody>
          </table>
        </div>
   
        <div class="modal-footer">
          <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>